export const ANNUAL_2024_PLAN_PRICE = '49';
export const ANNUAL_2024_PLAN_NAME = 'ANNUAL_2024';
export const ANNUAL_2025_PLAN_PRICE = '79';
export const ANNUAL_2025_PLAN_NAME = 'ANNUAL_2025';
export const ANNUAL_2026_VARIABLE_REWARDS = 'ANNUAL_2026_VARIABLE_REWARDS';
export const ANNUAL_2026_VARIABLE_REWARDS_PLAN_PRICE = '59';
export const FREE_TRIAL_2026_VARIABLE_REWARDS = 'FREE_TRIAL_2026_VARIABLE_REWARDS';

export const PLAN_PRICES: Record<string, string> = {
  [ANNUAL_2024_PLAN_NAME]: ANNUAL_2024_PLAN_PRICE,
  [ANNUAL_2025_PLAN_NAME]: ANNUAL_2025_PLAN_PRICE,
  [ANNUAL_2026_VARIABLE_REWARDS]: ANNUAL_2026_VARIABLE_REWARDS_PLAN_PRICE,
};

export const CA_PLAN_PRICE = '$35';
export const ANNUAL_PRICE = '$49.00';
